import Characteristics from '@r1-frontend/ui-react/components/List/Characteristics';
import { TCharacteristicsProps } from '@r1-frontend/ui-react/components/List/Characteristics/Characteristics';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { TRouterCardProps } from '@r1-frontend/ui-react/organisms/Card/Router/Router';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as S from './styled';

const DesktopRouterCard = ({
    title,
    description,

    characteristics,
}: Omit<TRouterCardProps, 'images' | 'Label' | 'characteristics'> & { characteristics: TCharacteristicsProps[] }): JSX.Element => {
    return (
        <>
            <ListContainer $size={24} $direction={'column'}>
                <ListContainer $size={4} $direction={'column'}>
                    <Paragraph5
                        $color={COLORS.TextHint}
                        // @ts-ignore
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                    <H4 $withIndent={false}>{title}</H4>
                    <S.Block>
                        {characteristics.map(characteristic => (
                            <Characteristics key={`Characteristic_${characteristic.title}`} {...characteristic} componentProps={{ $smaller: true }}/>
                        ))}
                    </S.Block>
                </ListContainer>
            </ListContainer>
        </>
    );
};

export default DesktopRouterCard;
